module.exports = __webpack_public_path__ + "img/car-tilt.61271612.svg";